import React, { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment-jalaali";
import "./index.css";
import "../../videocall/modal-vidobo/index.css";

function AddUserModal({ closeModal }) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [homeNumber, setHomeNumber] = useState("");
  const [userName, setUserName] = useState("");
  const [nationalId, setNationalId] = useState("");
  const [passWord, setPassWord] = useState("");
  const [passWordCheck, setPassWordCheck] = useState("");
  const [userAccess, setUserAccess] = useState("User");
  const [birthDay, setBirthDay] = useState(0);
  const [birthMonth, setBirthMonth] = useState(0);
  const [birthYear, setBirthYear] = useState(0);
  const [disorder, setDisorder] = useState("");
  const [sex, setSex] = useState("پسر");
  const [address, setAddress] = useState("");
  const [description, setDescription] = useState("");
  const [addUserError, setAddUserError] = useState(false);
  const [messageError, setMessageError] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const [digitalFiles, setDigitalFiles] = useState([]);

  useEffect(() => {
    console.log("TestAddUser", digitalFiles);
  });

  const formNextPage = () => {
    var birthDate = "";
    if (
      firstName == "" ||
      lastName == "" ||
      userName == "" ||
      passWord == "" ||
      passWordCheck == "" ||
      mobileNumber == "" ||
      birthDay == 0 ||
      birthMonth == 0 ||
      birthYear == 0
    ) {
      setAddUserError(true);
      setMessageError("لطفا تمامی مقادیر الزامی را وارد کنید");
      return;
    } else {
      birthDate = moment(
        birthYear.toString() +
          "/" +
          birthMonth.toString() +
          "/" +
          birthDay.toString() +
          " 00:00:00",
        "jYYYY/jM/jD HH:mm:ss"
      ).format("YYYY-M-D HH:mm:ss");
      setAddUserError(false);
    }

    if (passWord != passWordCheck) {
      setAddUserError(true);
      setMessageError("لطفا برابری مقادیر رمز عبور را چک کنید");
      return;
    } else {
      setAddUserError(false);
    }

    if (digitalFiles.length === 0) {
      digitalFiles.push({
        Id: 0,
        Date: "2022-09-13 10:21:43",
        Title: "شرایط حین تولد - تغذیه و دارو",
        Answers: ["", "", "", "خیر", "بلی", "خیر", "", "", "", ""],
      });
    } else if (digitalFiles.length === 1) {
      digitalFiles.push({
        Id: 1,
        Date: "2022-09-13 10:21:43",
        Title: "مراحل رشدی حرکتی",
        Answers: ["", "", "", "", "", "", "", ""],
      });
    } else if (digitalFiles.length === 2) {
      digitalFiles.push({
        Id: 2,
        Date: "2022-09-13 10:21:43",
        Title: "وضعیت جسمی و ذهنی",
        Answers: ["خیر", "", "خیر", "", "مرزی", "", "", "", ""],
      });
    }
    if (pageNumber < 3) {
      setPageNumber(pageNumber + 1);
    }
  };

  const formPrevPage = () => {
    if (pageNumber > 0) {
      setPageNumber(pageNumber - 1);
    } else {
      closeModal(false);
    }
  };

  const YesOrNoRadioInput = (event, element) => {
    const temp = digitalFiles;
    temp[0].Answers[element] = event.target.value;
    setDigitalFiles([...temp]);
  };

  const submitAddUser = async () => {
    var birthDate = "";
    if (
      firstName == "" ||
      lastName == "" ||
      userName == "" ||
      passWord == "" ||
      passWordCheck == "" ||
      mobileNumber == "" ||
      birthDay == 0 ||
      birthMonth == 0 ||
      birthYear == 0
    ) {
      setAddUserError(true);
      setMessageError("لطفا تمامی مقادیر الزامی را وارد کنید");
      return;
    } else {
      birthDate = moment(
        birthYear.toString() +
          "/" +
          birthMonth.toString() +
          "/" +
          birthDay.toString() +
          " 00:00:00",
        "jYYYY/jM/jD HH:mm:ss"
      ).format("YYYY-M-D HH:mm:ss");
      setAddUserError(false);
    }

    if (passWord != passWordCheck) {
      setAddUserError(true);
      setMessageError("لطفا برابری مقادیر رمز عبور را چک کنید");
      return;
    } else {
      setAddUserError(false);
    }

    const result = await axios.post(
      "https://request.kidiar.com/user/add",
      {
        firstname: firstName,
        lastname: lastName,
        useraccess: userAccess,
        mobilenumber: mobileNumber,
        homenumber: homeNumber,
        username: userName,
        password: passWord,
        nationalid: nationalId,
        birthdate: birthDate,
        disorder: disorder,
        sex: sex,
        address: address,
        description: description,
        digitalfiles: digitalFiles,
      },
      {
        headers: { "x-access-token": localStorage.getItem("token") },
      }
    );
    if (result.data.status == 1) {
      closeModal(false);
    } else {
      setAddUserError(true);
      setMessageError(result.data.message);
    }
  };

  return (
    <div className="modal-background">
      <div className="modal-container">
        <div className="modal-title">افزودن کاربر</div>
        <div className="users-modal-title mode-text-7">
          در اینجا می‌توانید با وارد کردن مشخصات خواسته شده، کاربر مورد نظر خود
          را به کلینیک هوشمند اضافه کنید.
        </div>
        {pageNumber === 0 && (
          <div className="users-modal-body">
            <div className="d-flex mb-2 mode-text-9 font-15 ">مشخصات اکانت</div>
            <div className="d-flex mb-2">
              <div className="d-flex w-50">
                <select
                  type="dropdown"
                  className="users-input w-100"
                  value={userAccess}
                  onChange={(e) => setUserAccess(e.target.value)}
                >
                  <option style={{ color: "#707070" }} value={0}>
                    نوع کاربر
                  </option>
                  <option value={"User"}>مراجع</option>
                  <option value={"Therapist"}>درمانگر</option>
                </select>
              </div>
              <div className="d-flex w-50">
                <input
                  type="text"
                  placeholder="نام کاربری"
                  className="users-input w-100 d-ltr"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                ></input>
              </div>
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex w-100">
                <input
                  type="password"
                  placeholder="رمز عبور"
                  className="users-input w-100 d-ltr"
                  value={passWord}
                  onChange={(e) => setPassWord(e.target.value)}
                ></input>
              </div>
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex w-100">
                <input
                  type="password"
                  placeholder="تکرار رمز عبور"
                  className="users-input w-100 d-ltr"
                  value={passWordCheck}
                  onChange={(e) => setPassWordCheck(e.target.value)}
                ></input>
              </div>
            </div>

            <div className="d-flex mb-2 mode-text-9 font-15 ">مشخصات فردی</div>
            <div className="d-flex mb-2">
              <div className="d-flex w-50">
                <input
                  type="text"
                  placeholder="نام"
                  className="users-input w-100"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                ></input>
              </div>
              <div className="d-flex w-50">
                <input
                  type="text"
                  placeholder="نام خانوادگی"
                  className="users-input w-100"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                ></input>
              </div>
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex w-50">
                <input
                  type="number"
                  placeholder="کد ملی"
                  className="users-input w-100"
                  value={nationalId}
                  onChange={(e) => setNationalId(e.target.value)}
                ></input>
              </div>
              <div className="d-flex w-50">
                <select
                  className="users-input"
                  style={{ width: "33.33%" }}
                  value={birthDay}
                  onChange={(e) => setBirthDay(e.target.value)}
                >
                  <option value={0}>روز</option>
                  <option value={1}>۱</option>
                  <option value={2}>۲</option>
                  <option value={3}>۳</option>
                  <option value={4}>۴</option>
                  <option value={5}>۵</option>
                  <option value={6}>۶</option>
                  <option value={7}>۷</option>
                  <option value={8}>۸</option>
                  <option value={9}>۹</option>
                  <option value={10}>۱۰</option>
                  <option value={11}>۱۱</option>
                  <option value={12}>۱۲</option>
                  <option value={13}>۱۳</option>
                  <option value={14}>۱۴</option>
                  <option value={15}>۱۵</option>
                  <option value={16}>۱۶</option>
                  <option value={17}>۱۷</option>
                  <option value={18}>۱۸</option>
                  <option value={19}>۱۹</option>
                  <option value={20}>۲۰</option>
                  <option value={21}>۲۱</option>
                  <option value={22}>۲۲</option>
                  <option value={23}>۲۳</option>
                  <option value={24}>۲۴</option>
                  <option value={25}>۲۵</option>
                  <option value={26}>۲۶</option>
                  <option value={27}>۲۷</option>
                  <option value={28}>۲۸</option>
                  <option value={29}>۲۹</option>
                  {birthMonth < 12 && <option value={30}>۳۰</option>}
                  {birthMonth < 7 && <option value={31}>۳۱</option>}
                </select>
                <select
                  className="users-input"
                  style={{ width: "33.33%" }}
                  value={birthMonth}
                  onChange={(e) => {
                    if (e.target.value < 7) {
                    } else if (birthDay == 31 && e.target.value < 12) {
                      setBirthDay(30);
                    } else if (birthDay == 31 && e.target.value == 12) {
                      setBirthDay(29);
                    } else if (birthDay == 30 && e.target.value == 12) {
                      setBirthDay(29);
                    }
                    setBirthMonth(e.target.value);
                  }}
                >
                  <option value={0}>ماه</option>
                  <option value={1}>فروردین</option>
                  <option value={2}>اردیبهشت</option>
                  <option value={3}>خرداد</option>
                  <option value={4}>تیر</option>
                  <option value={5}>مرداد</option>
                  <option value={6}>شهریور</option>
                  <option value={7}>مهر</option>
                  <option value={8}>آبان</option>
                  <option value={9}>آذر</option>
                  <option value={10}>دی</option>
                  <option value={11}>بهمن</option>
                  <option value={12}>اسفند</option>
                </select>
                <select
                  className="users-input"
                  style={{ width: "33.33%" }}
                  value={birthYear}
                  onChange={(e) => setBirthYear(e.target.value)}
                >
                  <option value={0}>سال</option>
                  <option value={1402}>۱۴۰۲</option>
                  <option value={1401}>۱۴۰۱</option>
                  <option value={1400}>۱۴۰۰</option>
                  <option value={1399}>۱۳۹۹</option>
                  <option value={1398}>۱۳۹۸</option>
                  <option value={1397}>۱۳۹۷</option>
                  <option value={1396}>۱۳۹۶</option>
                  <option value={1395}>۱۳۹۵</option>
                  <option value={1394}>۱۳۹۴</option>
                  <option value={1393}>۱۳۹۳</option>
                  <option value={1392}>۱۳۹۲</option>
                  <option value={1391}>۱۳۹۱</option>
                  <option value={1390}>۱۳۹۰</option>
                  <option value={1389}>۱۳۸۹</option>
                  <option value={1388}>۱۳۸۸</option>
                  <option value={1387}>۱۳۸۷</option>
                  <option value={1386}>۱۳۸۶</option>
                  <option value={1385}>۱۳۸۵</option>
                  <option value={1384}>۱۳۸۴</option>
                  <option value={1383}>۱۳۸۳</option>
                  <option value={1382}>۱۳۸۲</option>
                  <option value={1381}>۱۳۸۱</option>
                  <option value={1380}>۱۳۸۰</option>
                  <option value={1379}>۱۳۷۹</option>
                  <option value={1378}>۱۳۷۸</option>
                  <option value={1377}>۱۳۷۷</option>
                  <option value={1376}>۱۳۷۶</option>
                  <option value={1375}>۱۳۷۵</option>
                  <option value={1374}>۱۳۷۴</option>
                  <option value={1373}>۱۳۷۳</option>
                  <option value={1372}>۱۳۷۲</option>
                  <option value={1371}>۱۳۷۱</option>
                  <option value={1370}>۱۳۷۰</option>
                  <option value={1369}>۱۳۶۹</option>
                  <option value={1368}>۱۳۶۸</option>
                  <option value={1367}>۱۳۶۷</option>
                  <option value={1366}>۱۳۶۶</option>
                  <option value={1365}>۱۳۶۵</option>
                  <option value={1364}>۱۳۶۴</option>
                  <option value={1363}>۱۳۶۳</option>
                  <option value={1362}>۱۳۶۲</option>
                  <option value={1361}>۱۳۶۱</option>
                  <option value={1360}>۱۳۶۰</option>
                  <option value={1359}>۱۳۵۹</option>
                  <option value={1358}>۱۳۵۸</option>
                  <option value={1357}>۱۳۵۷</option>
                  <option value={1356}>۱۳۵۶</option>
                  <option value={1355}>۱۳۵۵</option>
                  <option value={1354}>۱۳۵۴</option>
                </select>
              </div>
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex w-50">
                <input
                  type="number"
                  placeholder="شماره موبایل"
                  className="users-input w-100"
                  value={mobileNumber}
                  onChange={(e) => setMobileNumber(e.target.value)}
                ></input>
              </div>
              <div className="d-flex w-50">
                <input
                  type="number"
                  placeholder="شماره منزل"
                  className="users-input w-100"
                  value={homeNumber}
                  onChange={(e) => setHomeNumber(e.target.value)}
                ></input>
              </div>
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex w-50">
                <input
                  type="text"
                  placeholder="نوع اختلال"
                  className="users-input w-100"
                  value={disorder}
                  onChange={(e) => setDisorder(e.target.value)}
                ></input>
              </div>
              <div className="d-flex w-50">
                <p className="users-modal-title mode-text-7">{"جنسیت:"}</p>
                <div className="d-flex w-50">
                  <input
                    type="radio"
                    className="users-input"
                    checked={sex === "پسر"}
                    value={"پسر"}
                    onChange={(e) => setSex(e.target.value)}
                  ></input>
                  <span className="mode-text-7">پسر</span>
                </div>
                <div className="d-flex w-50">
                  <input
                    type="radio"
                    className="users-input"
                    checked={sex === "دختر"}
                    value={"دختر"}
                    onChange={(e) => setSex(e.target.value)}
                  ></input>
                  <span className="mode-text-7">دختر</span>
                </div>
              </div>
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex w-100">
                <input
                  type="text"
                  placeholder="آدرس محل زندگی"
                  className="users-input w-100"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                ></input>
              </div>
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex w-100">
                <textarea
                  type="text"
                  placeholder="توضیحات بیشتر ..."
                  className="users-input w-100"
                  style={{ minHeight: "80px" }}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                ></textarea>
              </div>
            </div>
          </div>
        )}
        {pageNumber === 1 && (
          <div className="users-modal-body">
            <div className="d-flex mb-2 mode-text-9 font-15 ">
              شرایط حین تولد
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex w-50">
                <input
                  type="text"
                  placeholder="محل زایمان"
                  className="users-input w-100"
                  value={digitalFiles[0].Answers[0]}
                  onChange={(e) => {
                    const temp = digitalFiles;
                    temp[0].Answers[0] = e.target.value;
                    setDigitalFiles([...temp]);
                  }}
                ></input>
              </div>
              <div className="d-flex w-50">
                <select
                  type="dropdown"
                  className="users-input w-100"
                  value={digitalFiles[0].Answers[1]}
                  onChange={(e) => {
                    const temp = digitalFiles;
                    temp[0].Answers[1] = e.target.value;
                    setDigitalFiles([...temp]);
                  }}
                >
                  <option style={{ color: "#707070" }} value={0}>
                    نوع زایمان
                  </option>
                  <option value={"طبیعی"}>طبیعی</option>
                  <option value={"سزارین"}>سزارین</option>
                </select>
              </div>
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex w-50">
                <p className="users-modal-title mode-text-7 w-100">
                  {"وزن نوزاد به هنگام تولد"}
                </p>
              </div>
              <div className="d-flex w-50">
                <select
                  type="dropdown"
                  className="users-input w-50"
                  value={digitalFiles[0].Answers[2].substring(
                    digitalFiles[0].Answers[2].length - 3
                  )}
                  onChange={(e) => {
                    const temp = digitalFiles;
                    if (temp[0].Answers[2].length === 0)
                      temp[0].Answers[2] = "٫" + e.target.value;
                    if (temp[0].Answers[2].length === 1)
                      temp[0].Answers[2] =
                        temp[0].Answers[2].substring(0, 1) +
                        "٫" +
                        e.target.value;
                    if (temp[0].Answers[2].length === 4)
                      temp[0].Answers[2] = "٫" + e.target.value;
                    if (temp[0].Answers[2].length === 5)
                      temp[0].Answers[2] =
                        temp[0].Answers[2].substring(0, 1) +
                        "٫" +
                        e.target.value;
                    setDigitalFiles([...temp]);
                  }}
                >
                  <option style={{ color: "#707070" }} value={0}>
                    گرم
                  </option>
                  <option value={"۰۰۰"}>۰</option>
                  <option value={"۱۰۰"}>۱۰۰</option>
                  <option value={"۲۰۰"}>۲۰۰</option>
                  <option value={"۳۰۰"}>۳۰۰</option>
                  <option value={"۴۰۰"}>۴۰۰</option>
                  <option value={"۵۰۰"}>۵۰۰</option>
                  <option value={"۶۰۰"}>۶۰۰</option>
                  <option value={"۷۰۰"}>۷۰۰</option>
                  <option value={"۸۰۰"}>۸۰۰</option>
                  <option value={"۹۰۰"}>۹۰۰</option>
                </select>
                <select
                  type="dropdown"
                  className="users-input w-50"
                  value={digitalFiles[0].Answers[2].substring(0, 1)}
                  onChange={(e) => {
                    const temp = digitalFiles;
                    if (temp[0].Answers[2].length === 0)
                      temp[0].Answers[2] = e.target.value;
                    if (temp[0].Answers[2].length === 1)
                      temp[0].Answers[2] = e.target.value;
                    if (temp[0].Answers[2].length === 4)
                      temp[0].Answers[2] =
                        e.target.value +
                        "٫" +
                        temp[0].Answers[2].substring(
                          digitalFiles[0].Answers[2].length - 3
                        );
                    if (temp[0].Answers[2].length === 5)
                      temp[0].Answers[2] =
                        e.target.value +
                        "٫" +
                        temp[0].Answers[2].substring(
                          digitalFiles[0].Answers[2].length - 3
                        );
                    setDigitalFiles([...temp]);
                  }}
                >
                  <option style={{ color: "#707070" }} value={0}>
                    کیلو
                  </option>
                  <option value={"۰"}>۰</option>
                  <option value={"۱"}>۱</option>
                  <option value={"۲"}>۲</option>
                  <option value={"۳"}>۳</option>
                  <option value={"۴"}>۴</option>
                  <option value={"۵"}>۵</option>
                  <option value={"۶"}>۶</option>
                </select>
              </div>
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex w-50">
                <p className="users-modal-title mode-text-7 w-100">
                  {"آیا نیاز به بستری نوزاد بوده است؟"}
                </p>
              </div>
              <div className="d-flex w-50">
                <div className="d-flex w-50">
                  <input
                    type="radio"
                    className="users-input"
                    checked={digitalFiles[0].Answers[3] === "بلی"}
                    value={"بلی"}
                    onChange={(e) => YesOrNoRadioInput(e, 3)}
                  ></input>
                  <span className="mode-text-7">بلی</span>
                </div>
                <div className="d-flex w-50">
                  <input
                    type="radio"
                    className="users-input"
                    checked={digitalFiles[0].Answers[3] === "خیر"}
                    value={"خیر"}
                    onChange={(e) => YesOrNoRadioInput(e, 3)}
                  ></input>
                  <span className="mode-text-7">خیر</span>
                </div>
              </div>
            </div>
            <div className="d-flex mb-2 mode-text-9 font-15 ">تغذیه و دارو</div>
            <div className="d-flex mb-2">
              <div className="d-flex w-50">
                <p className="users-modal-title mode-text-7 w-100">
                  {"آیا کودک از شیر مادر تغذیه کرده است؟"}
                </p>
              </div>
              <div className="d-flex w-50">
                <div className="d-flex w-50">
                  <input
                    type="radio"
                    className="users-input"
                    checked={digitalFiles[0].Answers[4] === "بلی"}
                    value={"بلی"}
                    onChange={(e) => YesOrNoRadioInput(e, 4)}
                  ></input>
                  <span className="mode-text-7">بلی</span>
                </div>
                <div className="d-flex w-50">
                  <input
                    type="radio"
                    className="users-input"
                    checked={digitalFiles[0].Answers[4] === "خیر"}
                    value={"خیر"}
                    onChange={(e) => YesOrNoRadioInput(e, 4)}
                  ></input>
                  <span className="mode-text-7">خیر</span>
                </div>
              </div>
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex w-50">
                <p className="users-modal-title mode-text-7 w-100">
                  {"آیا کودک شب ادراری دارد؟"}
                </p>
              </div>
              <div className="d-flex w-50">
                <div className="d-flex w-50">
                  <input
                    type="radio"
                    className="users-input"
                    checked={digitalFiles[0].Answers[5] === "بلی"}
                    value={"بلی"}
                    onChange={(e) => YesOrNoRadioInput(e, 5)}
                  ></input>
                  <span className="mode-text-7">بلی</span>
                </div>
                <div className="d-flex w-50">
                  <input
                    type="radio"
                    className="users-input"
                    checked={digitalFiles[0].Answers[5] === "خیر"}
                    value={"خیر"}
                    onChange={(e) => YesOrNoRadioInput(e, 5)}
                  ></input>
                  <span className="mode-text-7">خیر</span>
                </div>
              </div>
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex w-100">
                <input
                  type="text"
                  placeholder="سوابق بیماری (مانند تشنج، کم خونی و ...)"
                  className="users-input w-100"
                  value={digitalFiles[0].Answers[6]}
                  onChange={(e) => {
                    const temp = digitalFiles;
                    temp[0].Answers[6] = e.target.value;
                    setDigitalFiles([...temp]);
                  }}
                ></input>
              </div>
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex w-100">
                <input
                  type="text"
                  placeholder="داروهای مصرفی (در حال حاظر)"
                  className="users-input w-100"
                  value={digitalFiles[0].Answers[7]}
                  onChange={(e) => {
                    const temp = digitalFiles;
                    temp[0].Answers[7] = e.target.value;
                    setDigitalFiles([...temp]);
                  }}
                ></input>
              </div>
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex w-100">
                <input
                  type="text"
                  placeholder="واکسن‌های لازم (باید انجام شود)"
                  className="users-input w-100"
                  value={digitalFiles[0].Answers[8]}
                  onChange={(e) => {
                    const temp = digitalFiles;
                    temp[0].Answers[8] = e.target.value;
                    setDigitalFiles([...temp]);
                  }}
                ></input>
              </div>
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex w-100">
                <textarea
                  type="text"
                  placeholder="توضیحات بیشتر ..."
                  className="users-input w-100"
                  style={{ minHeight: "80px" }}
                  value={digitalFiles[0].Answers[9]}
                  onChange={(e) => {
                    const temp = digitalFiles;
                    temp[0].Answers[9] = e.target.value;
                    setDigitalFiles([...temp]);
                  }}
                ></textarea>
              </div>
            </div>
          </div>
        )}
        {pageNumber === 2 && (
          <div className="users-modal-body">
            <div className="d-flex mb-2 mode-text-9 font-15 ">
              مراحل رشدی حرکتی
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex w-50">
                <p className="users-modal-title mode-text-7 w-100">
                  {"سنی که کودک توانست سرش را روی گردنش نگه دارد:"}
                </p>
              </div>
              <div className="d-flex w-50">
                <select
                  type="dropdown"
                  className="users-input w-50"
                  value={digitalFiles[1].Answers[0].substring(
                    digitalFiles[1].Answers[0].length - 2
                  )}
                  onChange={(e) => {
                    const temp = digitalFiles;
                    if (temp[1].Answers[0].length === 0)
                      temp[1].Answers[0] = "٫" + e.target.value;
                    if (temp[1].Answers[0].length === 1)
                      temp[1].Answers[0] =
                        temp[1].Answers[0].substring(0, 1) +
                        "٫" +
                        e.target.value;
                    if (temp[1].Answers[0].length === 3)
                      temp[1].Answers[0] = "٫" + e.target.value;
                    if (temp[1].Answers[0].length === 4)
                      temp[1].Answers[0] =
                        temp[1].Answers[0].substring(0, 1) +
                        "٫" +
                        e.target.value;
                    setDigitalFiles([...temp]);
                  }}
                >
                  <option style={{ color: "#707070" }} value={""}>
                    ماه
                  </option>
                  <option value={"۰۰"}>۰</option>
                  <option value={"۰۱"}>۱</option>
                  <option value={"۰۲"}>۲</option>
                  <option value={"۰۳"}>۳</option>
                  <option value={"۰۴"}>۴</option>
                  <option value={"۰۵"}>۵</option>
                  <option value={"۰۶"}>۶</option>
                  <option value={"۰۷"}>۷</option>
                  <option value={"۰۸"}>۸</option>
                  <option value={"۰۹"}>۹</option>
                  <option value={"۱۰"}>۱۰</option>
                  <option value={"۱۱"}>۱۱</option>
                  <option value={"۱۲"}>۱۲</option>
                </select>
                <select
                  type="dropdown"
                  className="users-input w-50"
                  value={digitalFiles[1].Answers[0].substring(0, 1)}
                  onChange={(e) => {
                    const temp = digitalFiles;
                    if (temp[1].Answers[0].length === 0)
                      temp[1].Answers[0] = e.target.value;
                    if (temp[1].Answers[0].length === 1)
                      temp[1].Answers[0] = e.target.value;
                    if (temp[1].Answers[0].length === 3)
                      temp[1].Answers[0] =
                        e.target.value +
                        "٫" +
                        temp[1].Answers[0].substring(
                          digitalFiles[1].Answers[0].length - 2
                        );
                    if (temp[1].Answers[0].length === 4)
                      temp[1].Answers[0] =
                        e.target.value +
                        "٫" +
                        temp[1].Answers[0].substring(
                          digitalFiles[1].Answers[0].length - 2
                        );
                    setDigitalFiles([...temp]);
                  }}
                >
                  <option style={{ color: "#707070" }} value={""}>
                    سال
                  </option>
                  <option value={"۰"}>۰</option>
                  <option value={"۱"}>۱</option>
                  <option value={"۲"}>۲</option>
                  <option value={"۳"}>۳</option>
                  <option value={"۴"}>۴</option>
                  <option value={"۵"}>۵</option>
                  <option value={"۶"}>۶</option>
                  <option value={"۷"}>۷</option>
                  <option value={"۸"}>۸</option>
                  <option value={"۹"}>۹</option>
                </select>
              </div>
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex w-50">
                <p className="users-modal-title mode-text-7 w-100">
                  {"سنی که کودک توانست بنشیند:"}
                </p>
              </div>
              <div className="d-flex w-50">
                <select
                  type="dropdown"
                  className="users-input w-50"
                  value={digitalFiles[1].Answers[1].substring(
                    digitalFiles[1].Answers[1].length - 2
                  )}
                  onChange={(e) => {
                    const temp = digitalFiles;
                    if (temp[1].Answers[1].length === 0)
                      temp[1].Answers[1] = "٫" + e.target.value;
                    if (temp[1].Answers[1].length === 1)
                      temp[1].Answers[1] =
                        temp[1].Answers[1].substring(0, 1) +
                        "٫" +
                        e.target.value;
                    if (temp[1].Answers[1].length === 3)
                      temp[1].Answers[1] = "٫" + e.target.value;
                    if (temp[1].Answers[1].length === 4)
                      temp[1].Answers[1] =
                        temp[1].Answers[1].substring(0, 1) +
                        "٫" +
                        e.target.value;
                    setDigitalFiles([...temp]);
                  }}
                >
                  <option style={{ color: "#707070" }} value={""}>
                    ماه
                  </option>
                  <option value={"۰۰"}>۰</option>
                  <option value={"۰۱"}>۱</option>
                  <option value={"۰۲"}>۲</option>
                  <option value={"۰۳"}>۳</option>
                  <option value={"۰۴"}>۴</option>
                  <option value={"۰۵"}>۵</option>
                  <option value={"۰۶"}>۶</option>
                  <option value={"۰۷"}>۷</option>
                  <option value={"۰۸"}>۸</option>
                  <option value={"۰۹"}>۹</option>
                  <option value={"۱۰"}>۱۰</option>
                  <option value={"۱۱"}>۱۱</option>
                  <option value={"۱۲"}>۱۲</option>
                </select>
                <select
                  type="dropdown"
                  className="users-input w-50"
                  value={digitalFiles[1].Answers[1].substring(0, 1)}
                  onChange={(e) => {
                    const temp = digitalFiles;
                    if (temp[1].Answers[1].length === 0)
                      temp[1].Answers[1] = e.target.value;
                    if (temp[1].Answers[1].length === 1)
                      temp[1].Answers[1] = e.target.value;
                    if (temp[1].Answers[1].length === 3)
                      temp[1].Answers[1] =
                        e.target.value +
                        "٫" +
                        temp[1].Answers[1].substring(
                          digitalFiles[1].Answers[1].length - 2
                        );
                    if (temp[1].Answers[1].length === 4)
                      temp[1].Answers[1] =
                        e.target.value +
                        "٫" +
                        temp[1].Answers[1].substring(
                          digitalFiles[1].Answers[1].length - 2
                        );
                    setDigitalFiles([...temp]);
                  }}
                >
                  <option style={{ color: "#707070" }} value={""}>
                    سال
                  </option>
                  <option value={"۰"}>۰</option>
                  <option value={"۱"}>۱</option>
                  <option value={"۲"}>۲</option>
                  <option value={"۳"}>۳</option>
                  <option value={"۴"}>۴</option>
                  <option value={"۵"}>۵</option>
                  <option value={"۶"}>۶</option>
                  <option value={"۷"}>۷</option>
                  <option value={"۸"}>۸</option>
                  <option value={"۹"}>۹</option>
                </select>
              </div>
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex w-50">
                <p className="users-modal-title mode-text-7 w-100">
                  {"سنی که کودک توانست چهار دست و پا برود:"}
                </p>
              </div>
              <div className="d-flex w-50">
                <select
                  type="dropdown"
                  className="users-input w-50"
                  value={digitalFiles[1].Answers[2].substring(
                    digitalFiles[1].Answers[2].length - 2
                  )}
                  onChange={(e) => {
                    const temp = digitalFiles;
                    if (temp[1].Answers[2].length === 0)
                      temp[1].Answers[2] = "٫" + e.target.value;
                    if (temp[1].Answers[2].length === 1)
                      temp[1].Answers[2] =
                        temp[1].Answers[2].substring(0, 1) +
                        "٫" +
                        e.target.value;
                    if (temp[1].Answers[2].length === 3)
                      temp[1].Answers[2] = "٫" + e.target.value;
                    if (temp[1].Answers[2].length === 4)
                      temp[1].Answers[2] =
                        temp[1].Answers[2].substring(0, 1) +
                        "٫" +
                        e.target.value;
                    setDigitalFiles([...temp]);
                  }}
                >
                  <option style={{ color: "#707070" }} value={""}>
                    ماه
                  </option>
                  <option value={"۰۰"}>۰</option>
                  <option value={"۰۱"}>۱</option>
                  <option value={"۰۲"}>۲</option>
                  <option value={"۰۳"}>۳</option>
                  <option value={"۰۴"}>۴</option>
                  <option value={"۰۵"}>۵</option>
                  <option value={"۰۶"}>۶</option>
                  <option value={"۰۷"}>۷</option>
                  <option value={"۰۸"}>۸</option>
                  <option value={"۰۹"}>۹</option>
                  <option value={"۱۰"}>۱۰</option>
                  <option value={"۱۱"}>۱۱</option>
                  <option value={"۱۲"}>۱۲</option>
                </select>
                <select
                  type="dropdown"
                  className="users-input w-50"
                  value={digitalFiles[1].Answers[2].substring(0, 1)}
                  onChange={(e) => {
                    const temp = digitalFiles;
                    if (temp[1].Answers[2].length === 0)
                      temp[1].Answers[2] = e.target.value;
                    if (temp[1].Answers[2].length === 1)
                      temp[1].Answers[2] = e.target.value;
                    if (temp[1].Answers[2].length === 3)
                      temp[1].Answers[2] =
                        e.target.value +
                        "٫" +
                        temp[1].Answers[2].substring(
                          digitalFiles[1].Answers[2].length - 2
                        );
                    if (temp[1].Answers[2].length === 4)
                      temp[1].Answers[2] =
                        e.target.value +
                        "٫" +
                        temp[1].Answers[2].substring(
                          digitalFiles[1].Answers[2].length - 2
                        );
                    setDigitalFiles([...temp]);
                  }}
                >
                  <option style={{ color: "#707070" }} value={""}>
                    سال
                  </option>
                  <option value={"۰"}>۰</option>
                  <option value={"۱"}>۱</option>
                  <option value={"۲"}>۲</option>
                  <option value={"۳"}>۳</option>
                  <option value={"۴"}>۴</option>
                  <option value={"۵"}>۵</option>
                  <option value={"۶"}>۶</option>
                  <option value={"۷"}>۷</option>
                  <option value={"۸"}>۸</option>
                  <option value={"۹"}>۹</option>
                </select>
              </div>
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex w-50">
                <p className="users-modal-title mode-text-7 w-100">
                  {"سنی که کودک توانست راه برود:"}
                </p>
              </div>
              <div className="d-flex w-50">
                <select
                  type="dropdown"
                  className="users-input w-50"
                  value={digitalFiles[1].Answers[3].substring(
                    digitalFiles[1].Answers[3].length - 2
                  )}
                  onChange={(e) => {
                    const temp = digitalFiles;
                    if (temp[1].Answers[3].length === 0)
                      temp[1].Answers[3] = "٫" + e.target.value;
                    if (temp[1].Answers[3].length === 1)
                      temp[1].Answers[3] =
                        temp[1].Answers[3].substring(0, 1) +
                        "٫" +
                        e.target.value;
                    if (temp[1].Answers[3].length === 3)
                      temp[1].Answers[3] = "٫" + e.target.value;
                    if (temp[1].Answers[3].length === 4)
                      temp[1].Answers[3] =
                        temp[1].Answers[3].substring(0, 1) +
                        "٫" +
                        e.target.value;
                    setDigitalFiles([...temp]);
                  }}
                >
                  <option style={{ color: "#707070" }} value={""}>
                    ماه
                  </option>
                  <option value={"۰۰"}>۰</option>
                  <option value={"۰۱"}>۱</option>
                  <option value={"۰۲"}>۲</option>
                  <option value={"۰۳"}>۳</option>
                  <option value={"۰۴"}>۴</option>
                  <option value={"۰۵"}>۵</option>
                  <option value={"۰۶"}>۶</option>
                  <option value={"۰۷"}>۷</option>
                  <option value={"۰۸"}>۸</option>
                  <option value={"۰۹"}>۹</option>
                  <option value={"۱۰"}>۱۰</option>
                  <option value={"۱۱"}>۱۱</option>
                  <option value={"۱۲"}>۱۲</option>
                </select>
                <select
                  type="dropdown"
                  className="users-input w-50"
                  value={digitalFiles[1].Answers[3].substring(0, 1)}
                  onChange={(e) => {
                    const temp = digitalFiles;
                    if (temp[1].Answers[3].length === 0)
                      temp[1].Answers[3] = e.target.value;
                    if (temp[1].Answers[3].length === 1)
                      temp[1].Answers[3] = e.target.value;
                    if (temp[1].Answers[3].length === 3)
                      temp[1].Answers[3] =
                        e.target.value +
                        "٫" +
                        temp[1].Answers[3].substring(
                          digitalFiles[1].Answers[3].length - 2
                        );
                    if (temp[1].Answers[3].length === 4)
                      temp[1].Answers[3] =
                        e.target.value +
                        "٫" +
                        temp[1].Answers[3].substring(
                          digitalFiles[1].Answers[3].length - 2
                        );
                    setDigitalFiles([...temp]);
                  }}
                >
                  <option style={{ color: "#707070" }} value={""}>
                    سال
                  </option>
                  <option value={"۰"}>۰</option>
                  <option value={"۱"}>۱</option>
                  <option value={"۲"}>۲</option>
                  <option value={"۳"}>۳</option>
                  <option value={"۴"}>۴</option>
                  <option value={"۵"}>۵</option>
                  <option value={"۶"}>۶</option>
                  <option value={"۷"}>۷</option>
                  <option value={"۸"}>۸</option>
                  <option value={"۹"}>۹</option>
                </select>
              </div>
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex w-50">
                <p className="users-modal-title mode-text-7 w-100">
                  {"سنی که کودک دندان‌های شیری درآورد:"}
                </p>
              </div>
              <div className="d-flex w-50">
                <select
                  type="dropdown"
                  className="users-input w-50"
                  value={digitalFiles[1].Answers[4].substring(
                    digitalFiles[1].Answers[4].length - 2
                  )}
                  onChange={(e) => {
                    const temp = digitalFiles;
                    if (temp[1].Answers[4].length === 0)
                      temp[1].Answers[4] = "٫" + e.target.value;
                    if (temp[1].Answers[4].length === 1)
                      temp[1].Answers[4] =
                        temp[1].Answers[4].substring(0, 1) +
                        "٫" +
                        e.target.value;
                    if (temp[1].Answers[4].length === 3)
                      temp[1].Answers[4] = "٫" + e.target.value;
                    if (temp[1].Answers[4].length === 4)
                      temp[1].Answers[4] =
                        temp[1].Answers[4].substring(0, 1) +
                        "٫" +
                        e.target.value;
                    setDigitalFiles([...temp]);
                  }}
                >
                  <option style={{ color: "#707070" }} value={""}>
                    ماه
                  </option>
                  <option value={"۰۰"}>۰</option>
                  <option value={"۰۱"}>۱</option>
                  <option value={"۰۲"}>۲</option>
                  <option value={"۰۳"}>۳</option>
                  <option value={"۰۴"}>۴</option>
                  <option value={"۰۵"}>۵</option>
                  <option value={"۰۶"}>۶</option>
                  <option value={"۰۷"}>۷</option>
                  <option value={"۰۸"}>۸</option>
                  <option value={"۰۹"}>۹</option>
                  <option value={"۱۰"}>۱۰</option>
                  <option value={"۱۱"}>۱۱</option>
                  <option value={"۱۲"}>۱۲</option>
                </select>
                <select
                  type="dropdown"
                  className="users-input w-50"
                  value={digitalFiles[1].Answers[4].substring(0, 1)}
                  onChange={(e) => {
                    const temp = digitalFiles;
                    if (temp[1].Answers[4].length === 0)
                      temp[1].Answers[4] = e.target.value;
                    if (temp[1].Answers[4].length === 1)
                      temp[1].Answers[4] = e.target.value;
                    if (temp[1].Answers[4].length === 3)
                      temp[1].Answers[4] =
                        e.target.value +
                        "٫" +
                        temp[1].Answers[4].substring(
                          digitalFiles[1].Answers[4].length - 2
                        );
                    if (temp[1].Answers[4].length === 4)
                      temp[1].Answers[4] =
                        e.target.value +
                        "٫" +
                        temp[1].Answers[4].substring(
                          digitalFiles[1].Answers[4].length - 2
                        );
                    setDigitalFiles([...temp]);
                  }}
                >
                  <option style={{ color: "#707070" }} value={""}>
                    سال
                  </option>
                  <option value={"۰"}>۰</option>
                  <option value={"۱"}>۱</option>
                  <option value={"۲"}>۲</option>
                  <option value={"۳"}>۳</option>
                  <option value={"۴"}>۴</option>
                  <option value={"۵"}>۵</option>
                  <option value={"۶"}>۶</option>
                  <option value={"۷"}>۷</option>
                  <option value={"۸"}>۸</option>
                  <option value={"۹"}>۹</option>
                </select>
              </div>
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex w-50">
                <p className="users-modal-title mode-text-7 w-100">
                  {"سنی که کودک شروع به حرف زدن کرد:"}
                </p>
              </div>
              <div className="d-flex w-50">
                <select
                  type="dropdown"
                  className="users-input w-50"
                  value={digitalFiles[1].Answers[5].substring(
                    digitalFiles[1].Answers[5].length - 2
                  )}
                  onChange={(e) => {
                    const temp = digitalFiles;
                    if (temp[1].Answers[5].length === 0)
                      temp[1].Answers[5] = "٫" + e.target.value;
                    if (temp[1].Answers[5].length === 1)
                      temp[1].Answers[5] =
                        temp[1].Answers[5].substring(0, 1) +
                        "٫" +
                        e.target.value;
                    if (temp[1].Answers[5].length === 3)
                      temp[1].Answers[5] = "٫" + e.target.value;
                    if (temp[1].Answers[5].length === 4)
                      temp[1].Answers[5] =
                        temp[1].Answers[5].substring(0, 1) +
                        "٫" +
                        e.target.value;
                    setDigitalFiles([...temp]);
                  }}
                >
                  <option style={{ color: "#707070" }} value={""}>
                    ماه
                  </option>
                  <option value={"۰۰"}>۰</option>
                  <option value={"۰۱"}>۱</option>
                  <option value={"۰۲"}>۲</option>
                  <option value={"۰۳"}>۳</option>
                  <option value={"۰۴"}>۴</option>
                  <option value={"۰۵"}>۵</option>
                  <option value={"۰۶"}>۶</option>
                  <option value={"۰۷"}>۷</option>
                  <option value={"۰۸"}>۸</option>
                  <option value={"۰۹"}>۹</option>
                  <option value={"۱۰"}>۱۰</option>
                  <option value={"۱۱"}>۱۱</option>
                  <option value={"۱۲"}>۱۲</option>
                </select>
                <select
                  type="dropdown"
                  className="users-input w-50"
                  value={digitalFiles[1].Answers[5].substring(0, 1)}
                  onChange={(e) => {
                    const temp = digitalFiles;
                    if (temp[1].Answers[5].length === 0)
                      temp[1].Answers[5] = e.target.value;
                    if (temp[1].Answers[5].length === 1)
                      temp[1].Answers[5] = e.target.value;
                    if (temp[1].Answers[5].length === 3)
                      temp[1].Answers[5] =
                        e.target.value +
                        "٫" +
                        temp[1].Answers[5].substring(
                          digitalFiles[1].Answers[5].length - 2
                        );
                    if (temp[1].Answers[5].length === 4)
                      temp[1].Answers[5] =
                        e.target.value +
                        "٫" +
                        temp[1].Answers[5].substring(
                          digitalFiles[1].Answers[5].length - 2
                        );
                    setDigitalFiles([...temp]);
                  }}
                >
                  <option style={{ color: "#707070" }} value={""}>
                    سال
                  </option>
                  <option value={"۰"}>۰</option>
                  <option value={"۱"}>۱</option>
                  <option value={"۲"}>۲</option>
                  <option value={"۳"}>۳</option>
                  <option value={"۴"}>۴</option>
                  <option value={"۵"}>۵</option>
                  <option value={"۶"}>۶</option>
                  <option value={"۷"}>۷</option>
                  <option value={"۸"}>۸</option>
                  <option value={"۹"}>۹</option>
                </select>
              </div>
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex w-50">
                <p className="users-modal-title mode-text-7 w-100">
                  {"سنی که کودک توانست ادرار و مدفوع خود را کنترل کند:"}
                </p>
              </div>
              <div className="d-flex w-50">
                <select
                  type="dropdown"
                  className="users-input w-50"
                  value={digitalFiles[1].Answers[6].substring(
                    digitalFiles[1].Answers[6].length - 2
                  )}
                  onChange={(e) => {
                    const temp = digitalFiles;
                    if (temp[1].Answers[6].length === 0)
                      temp[1].Answers[6] = "٫" + e.target.value;
                    if (temp[1].Answers[6].length === 1)
                      temp[1].Answers[6] =
                        temp[1].Answers[6].substring(0, 1) +
                        "٫" +
                        e.target.value;
                    if (temp[1].Answers[6].length === 3)
                      temp[1].Answers[6] = "٫" + e.target.value;
                    if (temp[1].Answers[6].length === 4)
                      temp[1].Answers[6] =
                        temp[1].Answers[6].substring(0, 1) +
                        "٫" +
                        e.target.value;
                    setDigitalFiles([...temp]);
                  }}
                >
                  <option style={{ color: "#707070" }} value={""}>
                    ماه
                  </option>
                  <option value={"۰۰"}>۰</option>
                  <option value={"۰۱"}>۱</option>
                  <option value={"۰۲"}>۲</option>
                  <option value={"۰۳"}>۳</option>
                  <option value={"۰۴"}>۴</option>
                  <option value={"۰۵"}>۵</option>
                  <option value={"۰۶"}>۶</option>
                  <option value={"۰۷"}>۷</option>
                  <option value={"۰۸"}>۸</option>
                  <option value={"۰۹"}>۹</option>
                  <option value={"۱۰"}>۱۰</option>
                  <option value={"۱۱"}>۱۱</option>
                  <option value={"۱۲"}>۱۲</option>
                </select>
                <select
                  type="dropdown"
                  className="users-input w-50"
                  value={digitalFiles[1].Answers[6].substring(0, 1)}
                  onChange={(e) => {
                    const temp = digitalFiles;
                    if (temp[1].Answers[6].length === 0)
                      temp[1].Answers[6] = e.target.value;
                    if (temp[1].Answers[6].length === 1)
                      temp[1].Answers[6] = e.target.value;
                    if (temp[1].Answers[6].length === 3)
                      temp[1].Answers[6] =
                        e.target.value +
                        "٫" +
                        temp[1].Answers[6].substring(
                          digitalFiles[1].Answers[6].length - 2
                        );
                    if (temp[1].Answers[6].length === 4)
                      temp[1].Answers[6] =
                        e.target.value +
                        "٫" +
                        temp[1].Answers[6].substring(
                          digitalFiles[1].Answers[6].length - 2
                        );
                    setDigitalFiles([...temp]);
                  }}
                >
                  <option style={{ color: "#707070" }} value={""}>
                    سال
                  </option>
                  <option value={"۰"}>۰</option>
                  <option value={"۱"}>۱</option>
                  <option value={"۲"}>۲</option>
                  <option value={"۳"}>۳</option>
                  <option value={"۴"}>۴</option>
                  <option value={"۵"}>۵</option>
                  <option value={"۶"}>۶</option>
                  <option value={"۷"}>۷</option>
                  <option value={"۸"}>۸</option>
                  <option value={"۹"}>۹</option>
                </select>
              </div>
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex w-100">
                <textarea
                  type="text"
                  placeholder="توضیحات بیشتر ..."
                  className="users-input w-100"
                  style={{ minHeight: "80px" }}
                  value={digitalFiles[1].Answers[7]}
                  onChange={(e) => {
                    const temp = digitalFiles;
                    temp[1].Answers[7] = e.target.value;
                    setDigitalFiles([...temp]);
                  }}
                ></textarea>
              </div>
            </div>
          </div>
        )}
        {pageNumber === 3 && (
          <div className="users-modal-body">
            <div className="d-flex mb-2 mode-text-9 font-15 ">
              وضعیت جسمی و ذهنی
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex w-50">
                <p className="users-modal-title mode-text-7 w-100">
                  {"آیا کودک در دستگاه گویایی نقص دارد؟"}
                </p>
              </div>
              <div className="d-flex w-50">
                <div className="d-flex w-50">
                  <input
                    type="radio"
                    className="users-input"
                    checked={digitalFiles[2].Answers[0] === "بلی"}
                    value={"بلی"}
                    onChange={(e) => {
                      const temp = digitalFiles;
                      temp[2].Answers[0] = e.target.value;
                      setDigitalFiles([...temp]);
                    }}
                  ></input>
                  <span className="mode-text-7">بلی</span>
                </div>
                <div className="d-flex w-50">
                  <input
                    type="radio"
                    className="users-input"
                    checked={digitalFiles[2].Answers[0] === "خیر"}
                    value={"خیر"}
                    onChange={(e) => {
                      const temp = digitalFiles;
                      temp[2].Answers[0] = e.target.value;
                      setDigitalFiles([...temp]);
                    }}
                  ></input>
                  <span className="mode-text-7">خیر</span>
                </div>
              </div>
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex w-100">
                <input
                  type="text"
                  placeholder="توضیحات بیشتر ..."
                  className="users-input w-100"
                  onChange={(e) => {
                    const temp = digitalFiles;
                    temp[2].Answers[1] = e.target.value;
                    setDigitalFiles([...temp]);
                  }}
                ></input>
              </div>
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex w-50">
                <p className="users-modal-title mode-text-7 w-100">
                  {"آیا کودک در دستگاه تنفسی نقص دارد؟"}
                </p>
              </div>
              <div className="d-flex w-50">
                <div className="d-flex w-50">
                  <input
                    type="radio"
                    className="users-input"
                    checked={digitalFiles[2].Answers[2] === "بلی"}
                    value={"بلی"}
                    onChange={(e) => {
                      const temp = digitalFiles;
                      temp[2].Answers[2] = e.target.value;
                      setDigitalFiles([...temp]);
                    }}
                  ></input>
                  <span className="mode-text-7">بلی</span>
                </div>
                <div className="d-flex w-50">
                  <input
                    type="radio"
                    className="users-input"
                    checked={digitalFiles[2].Answers[2] === "خیر"}
                    value={"خیر"}
                    onChange={(e) => {
                      const temp = digitalFiles;
                      temp[2].Answers[2] = e.target.value;
                      setDigitalFiles([...temp]);
                    }}
                  ></input>
                  <span className="mode-text-7">خیر</span>
                </div>
              </div>
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex w-100">
                <input
                  type="text"
                  placeholder="توضیحات بیشتر ..."
                  className="users-input w-100"
                  onChange={(e) => {
                    const temp = digitalFiles;
                    temp[2].Answers[3] = e.target.value;
                    setDigitalFiles([...temp]);
                  }}
                ></input>
              </div>
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex w-50">
                <p className="users-modal-title mode-text-7 w-100">
                  {"وضعیت هوشی کودک چگونه است؟"}
                </p>
              </div>
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex w-100">
                <div className="d-flex w-25">
                  <input
                    type="radio"
                    className="users-input"
                    checked={digitalFiles[2].Answers[4] === "مرزی"}
                    value={"مرزی"}
                    onChange={(e) => {
                      const temp = digitalFiles;
                      temp[2].Answers[4] = e.target.value;
                      setDigitalFiles([...temp]);
                    }}
                  ></input>
                  <span className="mode-text-7">مرزی</span>
                </div>
                <div className="d-flex w-25">
                  <input
                    type="radio"
                    className="users-input"
                    checked={digitalFiles[2].Answers[4] === "آموزش‌پذیر پایین"}
                    value={"آموزش‌پذیر پایین"}
                    onChange={(e) => {
                      const temp = digitalFiles;
                      temp[2].Answers[4] = e.target.value;
                      setDigitalFiles([...temp]);
                    }}
                  ></input>
                  <span className="mode-text-7">آموزش‌پذیر پایین</span>
                </div>
                <div className="d-flex w-25">
                  <input
                    type="radio"
                    className="users-input"
                    checked={digitalFiles[2].Answers[4] === "آموزش‌پذیر متوسط"}
                    value={"آموزش‌پذیر متوسط"}
                    onChange={(e) => {
                      const temp = digitalFiles;
                      temp[2].Answers[4] = e.target.value;
                      setDigitalFiles([...temp]);
                    }}
                  ></input>
                  <span className="mode-text-7">آموزش‌پذیر متوسط</span>
                </div>
                <div className="d-flex w-25">
                  <input
                    type="radio"
                    className="users-input"
                    checked={digitalFiles[2].Answers[4] === "آموزش‌پذیر بالا"}
                    value={"آموزش‌پذیر بالا"}
                    onChange={(e) => {
                      const temp = digitalFiles;
                      temp[2].Answers[4] = e.target.value;
                      setDigitalFiles([...temp]);
                    }}
                  ></input>
                  <span className="mode-text-7">آموزش‌پذیر بالا</span>
                </div>
              </div>
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex w-100">
                <input
                  type="text"
                  placeholder="وضعیت شنوایی کودک ..."
                  className="users-input w-100"
                  onChange={(e) => {
                    const temp = digitalFiles;
                    temp[2].Answers[5] = e.target.value;
                    setDigitalFiles([...temp]);
                  }}
                ></input>
              </div>
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex w-100">
                <input
                  type="text"
                  placeholder="وضعیت بینایی کودک ..."
                  className="users-input w-100"
                  onChange={(e) => {
                    const temp = digitalFiles;
                    temp[2].Answers[6] = e.target.value;
                    setDigitalFiles([...temp]);
                  }}
                ></input>
              </div>
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex w-100">
                <input
                  type="text"
                  placeholder="وضعیت حرکتی کودک ..."
                  className="users-input w-100"
                  onChange={(e) => {
                    const temp = digitalFiles;
                    temp[2].Answers[7] = e.target.value;
                    setDigitalFiles([...temp]);
                  }}
                ></input>
              </div>
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex w-100">
                <textarea
                  type="text"
                  placeholder="توضیحات بیشتر ..."
                  className="users-input w-100"
                  style={{ minHeight: "80px" }}
                  onChange={(e) => {
                    const temp = digitalFiles;
                    temp[2].Answers[8] = e.target.value;
                    setDigitalFiles([...temp]);
                  }}
                ></textarea>
              </div>
            </div>
          </div>
        )}
        <div className="modal-footer mode-bg-8 d-ltr">
          <button onClick={formPrevPage}>
            {pageNumber === 0 ? "انصراف" : "بازگشت"}
          </button>
          <button onClick={submitAddUser}>تایید</button>
          {pageNumber !== 3 && <button onClick={formNextPage}>ادامه</button>}
        </div>
        <div className="error-text">
          {addUserError && <p>{messageError}</p>}
        </div>
      </div>
    </div>
  );
}

export default AddUserModal;
